import { MontadorOperacao } from "@/components/canvas/MontadorOperacao";
import { ComSlotAcoes } from "@/components/layout/SlotAcoes";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { TipoNo } from "@/types";

const PAPEIS_ECE: TipoNo[] = ["PRODUTOR", "ECE", "ARMAZEM", "DISTRIBUIDORA", "EXTERIOR"];

export function VendasEcePage() {
  return (
    <div className="space-y-5">
      <Tabs defaultValue="ordem">
        <ComSlotAcoes
          abas={
            <TabsList>
              <TabsTrigger value="ordem">Venda à Ordem</TabsTrigger>
              <TabsTrigger value="armazenagem">Armazenagem</TabsTrigger>
              <TabsTrigger value="exportacao">Exportação</TabsTrigger>
            </TabsList>
          }
        >
          <TabsContent value="ordem">
            <MontadorOperacao
              contexto="ordem"
              chaveModelo="ordem"
              titulo="Venda à Ordem"
              descricao="Produtor fatura para a ECE, que revende ao cliente; a entrega física sai direto do produtor por conta e ordem."
              papeis={PAPEIS_ECE}
              produtos={["hidratado", "anidro"]}
            />
          </TabsContent>

          <TabsContent value="armazenagem">
            <MontadorOperacao
              contexto="armazenagem"
              chaveModelo="armazenagem"
              titulo="Armazenagem"
              descricao="Compra com entrega em armazém, remessas simbólicas e retornos — inclui a suspensão do ICMS nas rotas Logum (EHC)."
              papeis={PAPEIS_ECE}
              produtos={["hidratado", "anidro"]}
            />
          </TabsContent>

          <TabsContent value="exportacao">
            <MontadorOperacao
              contexto="exportacao"
              chaveModelo="exportacao"
              titulo="Exportação"
              descricao="Venda com fim específico de exportação, formação de lote em terminal e embarque com DU-E."
              papeis={PAPEIS_ECE}
              produtos={["hidratado", "anidro"]}
            />
          </TabsContent>
        </ComSlotAcoes>
      </Tabs>
    </div>
  );
}
